/* Lilibloom · article "guide" template: header offset, reading progress, contents,
   checklist (saved in the browser, shared on WhatsApp), FAQ height animation, gentle reveals.
   Everything is readable without it. */
(function () {
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  var root = $('[data-lbx]');
  if (!root) return;
  var body = $('.lbx-body', root);
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- sticky parts sit under whatever header is showing ---------- */
  function headerBottom() {
    var b = 0;
    $$('.shopify-section--announcement-bar, .shopify-section--header, #shopify-section-announcement-bar, .shopify-section-group-header-group').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (getComputedStyle(el).position === 'sticky' || getComputedStyle(el.firstElementChild || el).position === 'sticky') b = Math.max(b, r.bottom);
    });
    return Math.max(0, Math.round(b));
  }
  var settle;
  function syncSticky() { root.style.setProperty('--lbx-sticky', headerBottom() + 'px'); }

  /* ---------- reading progress ---------- */
  var bar = $('.lbx-progress', root);
  function progress() {
    var r = body.getBoundingClientRect();
    var p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - window.innerHeight * 0.6)));
    bar.style.setProperty('--lbx-p', p.toFixed(4));
  }

  /* ---------- contents, built from the body's h2 ---------- */
  var toc = $('.lbx-toc', root), list = $('.lbx-toc__list', root), box = $('.lbx-toc__box', root);
  var heads = $$('h2[id]', body).filter(function (h) { return !h.closest('.lbx-tldr, .lbx-sources'); });
  var links = heads.map(function (h) {
    var li = document.createElement('li'), a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.getAttribute('data-toc') || h.textContent.replace(/\?$/, '').trim();
    li.appendChild(a); list.appendChild(li);
    return a;
  });
  if (heads.length > 2) toc.hidden = false;
  var desk = window.matchMedia('(min-width: 1100px)');
  function syncToc() { box.open = desk.matches; }
  syncToc();
  if (desk.addEventListener) desk.addEventListener('change', syncToc);
  links.forEach(function (a) { a.addEventListener('click', function () { if (!desk.matches) box.open = false; }); });
  function markToc() {
    var line = window.innerHeight * 0.3, cur = -1;
    heads.forEach(function (h, i) { if (h.getBoundingClientRect().top <= line) cur = i; });
    links.forEach(function (a, i) { if (i === cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; syncSticky(); progress(); markToc(); });
    clearTimeout(settle);
    settle = setTimeout(syncSticky, 450); // after the header finishes sliding
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  syncSticky(); progress(); markToc();

  /* ---------- checklist ---------- */
  $$('[data-lbx-check]', root).forEach(function (chk) {
    var key = 'lb-check-' + chk.getAttribute('data-lbx-check');
    var inputs = $$('input[type="checkbox"]', chk);
    var doneEl = $('[data-done]', chk), share = $('[data-share]', chk), reset = $('[data-reset]', chk);
    var title = chk.getAttribute('data-share-title') || 'מה עוד חסר:';
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem(key) || '{}') || {}; } catch (e) { saved = {}; }
    inputs.forEach(function (i) { i.checked = !!saved[i.value]; });

    function render(fromUser) {
      var done = inputs.filter(function (i) { return i.checked; }).length;
      var full = done === inputs.length;
      doneEl.textContent = done;
      chk.style.setProperty('--p', (done / inputs.length).toFixed(3));
      if (full && fromUser) { chk.classList.remove('is-full'); void chk.offsetWidth; }
      chk.classList.toggle('is-full', full);
      var lines = [title];
      $$('.lbx-group', chk).forEach(function (g) {
        var miss = $$('input', g).filter(function (i) { return !i.checked; });
        if (!miss.length) return;
        lines.push('', '*' + $('legend', g).firstChild.textContent.trim() + '*');
        miss.forEach(function (i) { lines.push('▫️ ' + i.nextElementSibling.textContent.trim()); });
      });
      if (lines.length === 1) lines = ['הכול ארוז! 🎒'];
      lines.push('', location.origin + location.pathname);
      share.href = 'https://wa.me/?text=' + encodeURIComponent(lines.join('\n'));
      share.textContent = full ? 'שלחי שהכול ארוז' : 'שלחי מה חסר לך';
    }
    function save() {
      var s = {};
      inputs.forEach(function (i) { if (i.checked) s[i.value] = 1; });
      try { localStorage.setItem(key, JSON.stringify(s)); } catch (e) { /* private mode: works for this visit */ }
    }
    chk.addEventListener('change', function () { save(); render(true); });
    reset.addEventListener('click', function () { inputs.forEach(function (i) { i.checked = false; }); save(); render(false); });
    render(false);
  });

  /* ---------- FAQ: animate the height ---------- */
  $$('.lbx-qa', root).forEach(function (d) {
    var sum = $('summary', d), ans = $('.lbx-ans', d);
    if (reduce || !ans.animate) return;
    sum.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (d.dataset.busy) return;
      d.dataset.busy = '1';
      if (d.open) {
        ans.animate([{ height: ans.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 300, easing: 'cubic-bezier(.4,0,.2,1)' })
          .onfinish = function () { d.open = false; delete d.dataset.busy; };
      } else {
        d.open = true;
        ans.animate([{ height: '0px', opacity: 0 }, { height: ans.offsetHeight + 'px', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.22,1,.36,1)' })
          .onfinish = function () { delete d.dataset.busy; };
      }
    });
  });

  /* ---------- stretch test: pull both swatches, release; "a" keeps part of the stretch ---------- */
  $$('[data-lbx-stretch]', root).forEach(function (fig) {
    var range = $('input[type="range"]', fig), again = $('[data-again]', fig), live = $('.lbx-stretch__live', fig);
    var sa = $('[data-row="a"] .lbx-stretch__swatch', fig), sb = $('[data-row="b"] .lbx-stretch__swatch', fig);
    var kept = 1, peak = 0, demoed = false;
    function pull(v) {
      fig.classList.remove('is-released');
      peak = Math.max(peak, v);
      sa.style.setProperty('--s', Math.max(kept, 1 + v * 0.62).toFixed(3));
      sb.style.setProperty('--s', (1 + v * 0.62).toFixed(3));
    }
    function release() {
      if (!peak) return;
      kept = Math.max(kept, 1 + peak * 0.2);
      fig.classList.add('is-released');
      sa.style.setProperty('--s', kept.toFixed(3));
      sb.style.setProperty('--s', '1');
      range.value = 0; peak = 0;
      live.textContent = $('[data-row="a"] .lbx-stretch__after', fig).textContent + '. ' + $('[data-row="b"] .lbx-stretch__after', fig).textContent + '.';
    }
    range.addEventListener('input', function () { pull(range.value / 100); });
    ['change', 'pointerup', 'touchend', 'keyup'].forEach(function (ev) { range.addEventListener(ev, release); });
    again.addEventListener('click', function () {
      kept = 1; fig.classList.remove('is-released');
      sa.style.setProperty('--s', '1'); sb.style.setProperty('--s', '1');
    });
    // one gentle demo the first time it comes into view
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting || demoed) return;
      demoed = true; io.disconnect();
      var t0 = null;
      (function step(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / 900), v = 0.7 * (1 - Math.pow(1 - p, 3));
        range.value = Math.round(v * 100); pull(v);
        if (p < 1) requestAnimationFrame(step); else setTimeout(release, 250);
      })(performance.now());
    }, { threshold: 0.6 });
    io.observe(fig);
  });

  /* ---------- picker: chips highlight the options that fit ---------- */
  $$('[data-lbx-picker]', root).forEach(function (pk) {
    var chips = $$('.lbx-chip', pk), opts = $$('.lbx-opt', pk), answers = $$('.lbx-picker__answer', pk);
    $('.lbx-picker__opts', pk).style.setProperty('--n', opts.length); $('.lbx-picker__opts', pk).setAttribute('data-n', opts.length);
    $('.lbx-picker__chips', pk).hidden = false;
    pk.classList.add('is-on');
    answers.forEach(function (a) { a.setAttribute('aria-live', 'polite'); });
    function pick(btn) {
      var best = (btn.getAttribute('data-best') || '').split(',');
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === btn ? 'true' : 'false'); });
      opts.forEach(function (o) { o.classList.toggle('is-best', best.indexOf(o.getAttribute('data-id')) > -1); });
      answers.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-for') === btn.getAttribute('data-i')); });
    }
    chips.forEach(function (c) { c.addEventListener('click', function () { pick(c); }); });
    if (chips[0]) pick(chips[0]);
  });

  /* ---------- stage timeline: the line fills with the scroll, stages light up as it passes ---------- */
  $$('[data-lbx-tl]', root).forEach(function (tl) {
    var items = $$('.lbx-tl__item', tl);
    if (reduce) { items.forEach(function (it) { it.classList.add('is-lit'); }); return; }
    tl.classList.add('is-on');
    var tick = false;
    function draw() {
      tick = false;
      var r = tl.getBoundingClientRect(), line = window.innerHeight * 0.62;
      var p = Math.min(1, Math.max(0, (line - r.top) / Math.max(1, r.height)));
      tl.style.setProperty('--tp', p.toFixed(3));
      items.forEach(function (it) { it.classList.toggle('is-lit', it.getBoundingClientRect().top + 14 <= line); });
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(draw); } }, { passive: true });
    window.addEventListener('resize', draw);
    draw();
  });

  /* ---------- calculators: cost over time, how many pairs, bralette size ----------
     Each kind returns { k: line above the number, big: the number, sub: line under it, more: extra html, cta: label }. */
  var fmt = function (n) { return '₪' + Math.round(n).toLocaleString('he-IL'); };
  var num = function (n) { return Math.round(n).toLocaleString('he-IL'); };
  function tierFor(n, tiers) { var d = 0; (tiers || []).forEach(function (t) { if (n >= t[0] && t[1] > d) d = t[1]; }); return d; }
  var calcs = {
    cost: function (v, P) {
      var monthly = v.per_day * v.days * v.price, H = P.horizon || 24;
      if (!(monthly > 0)) return { k: 'הקלידי כמה ביום, כמה ימים בחודש, ומחיר ליחידה.' };
      var pairs = Math.max(1, Math.round(v.pairs || 1)), disc = tierFor(pairs, P.tiers);
      var reusable = pairs * P.unit_price * (1 - disc), back = reusable / monthly;
      return {
        k: 'ב־' + H + ' החודשים הקרובים תוציאי על ' + P.a_label,
        big: fmt(monthly * H),
        sub: '<b>' + fmt(monthly * 12) + '</b> בשנה · <b>' + num(v.per_day * v.days * H) + '</b> ' + (P.a_unit || 'יחידות') + ' לפח',
        more: '<div class="lbx-res__vs"><h3>' + (P.b_title || 'ועם רב פעמיים?') + '</h3><p>' + pairs + ' ' + P.b_label + ' עולים <b class="lbx-ltr">' + fmt(reusable) + '</b>' +
          (disc ? ' (כולל ' + Math.round(disc * 100) + '% הנחה)' : '') + ', ומחזירים את עצמם תוך <em>' + (back < 1 ? 'פחות מחודש' : 'כ־' + Math.ceil(back) + ' חודשים') + '</em>.</p></div>',
        cta: (P.cta_label || '').replace('{n}', pairs)
      };
    },
    pairs: function (v, P) {
      var days = Math.max(1, Math.round(v.days)), heavy = Math.min(days, Math.max(0, Math.round(v.heavy))), wash = Math.max(1, Math.round(v.wash));
      var win = Math.min(days, wash + 1), n = 0;
      for (var i = 0; i < win; i++) n += i < heavy ? 2 : 1;
      var disc = tierFor(n, P.tiers), icons = '', pack = n <= 3 ? 3 : (n <= 5 ? 5 : 7);
      for (var k = 0; k < n; k++) icons += '<i style="--k:' + k + '"></i>';
      return {
        k: 'כדי לעבור מחזור שלם עם כביסה באמצע, תצטרכי',
        big: n + ' זוגות',
        sub: P.explain || '',
        more: '<div class="lbx-calc__stack" data-icon="undies" aria-hidden="true">' + icons + '</div>' +
          '<div class="lbx-res__vs"><p>' + (disc ? 'על ' + n + ' זוגות יש הנחה אוטומטית של <em>' + Math.round(disc * 100) + '%</em>.' : 'מ־3 זוגות יש הנחה אוטומטית: <em>5%</em> על 3, <em>10%</em> על 5 ו־<em>15%</em> על 7.') + '</p></div>',
        cta: (P.cta_label || '').replace('{n}', pack)
      };
    },
    bra: function (v, P, tab) {
      var under = v.under, bust = v.bust;
      if (tab === 'bra') { under = Number(v.band); bust = under + 13 + 2 * Number(v.cup); }
      if (!(under > 0)) return { k: 'הקלידי היקף מתחת לחזה והיקף חזה בסנטימטרים.' };
      function sizeIn(cut) {
        var T = P.tables[cut] || [], byU = null, byB = null, best = null, gap = 99;
        T.forEach(function (r) {
          if (under >= r[3] && under <= r[4]) byU = byU || r[0];
          if (r[1] && bust >= r[1] && bust <= r[2]) byB = byB || r[0];
          var d = Math.min(Math.abs(under - r[3]), Math.abs(under - r[4]));
          if (d < gap) { gap = d; best = r[0]; }
        });
        if (!byU && gap <= 2) byU = best;
        return { u: byU, b: byB, main: byU || byB };
      }
      var cut = v.cut, s = sizeIn(cut), name = P.names[cut] || '';
      if (!s.main) {
        var alt = (P.order || []).filter(function (c) { return c !== cut && sizeIn(c).main; })[0];
        if (alt) return { k: 'ב' + name + ' אין מידה כזו. הכי קרוב:', big: sizeIn(alt).main, sub: 'בגוזיית ' + P.names[alt] + '.', cta: 'לגוזיית ' + P.names[alt], url: (P.urls || {})[alt] };
        return { k: 'המידות מחוץ לטבלה של ' + name + '.', sub: 'כתבי לנו בוואטסאפ ונעזור לבחור.' };
      }
      var sub = s.u && s.b && s.u !== s.b ? 'מתחת לחזה מתאים ל־' + s.u + ' והחזה ל־' + s.b + '. בגוזייה רכה בוחרים לפי ההיקף מתחת לחזה.' : (tab === 'bra' ? 'הערכה לפי מידת החזייה.' : 'לפי טבלת המידות של הדגם.');
      var others = (P.order || []).filter(function (c) { return c !== cut && (P.teen || []).indexOf(c) === -1 && (P.teen || []).indexOf(cut) === -1; });
      var diff = others.filter(function (c) { return sizeIn(c).main !== s.main; });
      var rows = diff.map(function (c) { var o = sizeIn(c); return '<li><span>' + P.names[c] + '</span><i></i><b>' + (o.main || 'אין במידה הזו') + '</b></li>'; }).join('');
      var more = !others.length ? '' : '<div class="lbx-res__vs">' + (rows
        ? '<h3>ובשאר הגוזיות</h3><p>' + s.main + ' גם בשאר הגוזיות, חוץ מ:</p><ul class="lbx-res__rows">' + rows + '</ul>'
        : '<p>זו המידה שלך <em>בכל הגוזיות שלנו לנשים</em>.</p>') + '</div>';
      return {
        k: 'המידה שלך ב' + name,
        big: s.main,
        sub: sub,
        more: more,
        cta: 'לגוזיית ' + name,
        url: (P.urls || {})[cut]
      };
    }
  };
  $$('[data-lbx-calc]', root).forEach(function (box) {
    var kind = box.getAttribute('data-lbx-calc'), P = {};
    try { P = JSON.parse(box.getAttribute('data-params') || '{}') || {}; } catch (e) { P = {}; }
    var out = $('.lbx-calc__out', box), cta = $('[data-cta]', box), tabs = $$('[data-tab]', box), tab = tabs[0] ? tabs[0].getAttribute('data-tab') : null;
    var shown = null;
    function syncTabs() {
      tabs.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-tab') === tab ? 'true' : 'false'); });
      $$('[data-in-tab]', box).forEach(function (f) { f.hidden = f.getAttribute('data-in-tab') !== tab; });
    }
    function values() {
      var v = {};
      $$('[data-f]', box).forEach(function (f) {
        if (f.type === 'radio' && !f.checked) return;
        var x = f.value; v[f.getAttribute('data-f')] = isNaN(Number(x)) ? x : Number(x);
      });
      return v;
    }
    function run() {
      $$('.lbx-q__range', box).forEach(function (r) {
        var o = $('[data-out="' + r.getAttribute('data-f') + '"]', box); if (o) o.textContent = r.value;
        r.style.setProperty('--p', ((r.value - r.min) / (r.max - r.min) * 100) + '%');
      });
      var r = (calcs[kind] || function () { return {}; })(values(), P, tab);
      out.innerHTML = (r.k ? '<p class="lbx-res__k">' + r.k + '</p>' : '') + (r.big ? '<p class="lbx-res__big"><span class="lbx-ltr">' + r.big + '</span></p>' : '') +
        (r.sub ? '<p class="lbx-res__sub">' + r.sub + '</p>' : '') + (r.more || '');
      var big = $('.lbx-res__big', out);
      if (big && r.big !== shown) { big.classList.remove('is-new'); void big.offsetWidth; big.classList.add('is-new'); shown = r.big; }
      if (cta) { cta.hidden = !r.cta; $('[data-cta-t]', cta).textContent = r.cta || ''; if (r.url) cta.href = r.url; }
    }
    $$('.lbx-q__stp button', box).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = $('input', b.parentNode), st = Number(i.step) || 1, x = (Number(i.value) || 0) + st * Number(b.getAttribute('data-step'));
        i.value = Math.min(Number(i.max), Math.max(Number(i.min), Math.round(x / st) * st)); run();
      });
    });
    tabs.forEach(function (b) { b.addEventListener('click', function () { tab = b.getAttribute('data-tab'); syncTabs(); run(); }); });
    box.addEventListener('input', run); box.addEventListener('change', run);
    syncTabs(); run();
  });

  /* ---------- before / after toggle ---------- */
  $$('[data-lbx-toggle]', root).forEach(function (fig) {
    var btns = $$('[data-show]', fig), panes = $$('[data-pane]', fig);
    $('.lbx-toggle__btns', fig).hidden = false; fig.classList.add('is-on');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-show');
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        panes.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-pane') === k); });
      });
    });
  });

  /* ---------- exercise timer: tighten while holding, open while resting ---------- */
  $$('[data-lbx-timer]', root).forEach(function (tm) {
    var hold = +tm.getAttribute('data-hold'), rest = +tm.getAttribute('data-rest'), reps = +tm.getAttribute('data-reps');
    var hl = tm.getAttribute('data-hold-label'), rl = tm.getAttribute('data-rest-label');
    var core = $('.lbx-timer__core', tm), count = $('.lbx-timer__count', tm), state = $('.lbx-timer__state', tm), btn = $('[data-start]', tm), repEl = $('[data-rep]', tm);
    var timer = null, phase = 'hold', left = hold, rep = 0;
    $('.lbx-timer__ctrl', tm).hidden = false;
    function show() {
      count.textContent = left;
      state.textContent = phase === 'hold' ? hl : rl;
      core.style.setProperty('--dur', (phase === 'hold' ? hold : rest) + 's');
      core.style.setProperty('--sc', phase === 'hold' ? '.68' : '1');
      repEl.textContent = rep;
    }
    function stop(done) {
      clearInterval(timer); timer = null; btn.textContent = done ? 'שוב' : 'להמשיך';
      if (done) { state.textContent = 'כל הכבוד, סיימת סבב.'; count.textContent = ''; core.style.setProperty('--sc', '1'); phase = 'hold'; left = hold; rep = 0; }
    }
    function tick() {
      left--;
      if (left <= 0) {
        if (phase === 'hold') { phase = 'rest'; left = rest; }
        else { rep++; if (rep >= reps) { repEl.textContent = rep; return stop(true); } phase = 'hold'; left = hold; }
      }
      show();
    }
    btn.addEventListener('click', function () {
      if (timer) return stop(false);
      btn.textContent = 'לעצור'; show(); timer = setInterval(tick, 1000);
    });
  });

  /* ---------- reveals: only for parts that start below the fold ---------- */
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('lbx-pre'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -12% 0px' });
    $$('.lbx-weeks, .lbx-stages, .lbx-prod, .lbx-pair', root).forEach(function (el) {
      if (el.getBoundingClientRect().top > window.innerHeight) {
        el.classList.add('lbx-pre');
        if (el.matches('.lbx-prod, .lbx-pair')) el.classList.add('lbx-rise');
        io.observe(el);
      }
    });
  }
})();
